import { getBillingSettings } from "./root";

import { createLookupCombiner, createLookupSelectors } from "./lib";
import { selectBillingSettingsIdByBillingRunIdLookup } from "./indexes";

export const getBillingSettingsById = billingSettingsId => state =>
  getBillingSettings(state)[billingSettingsId] || null;

// Pull out the first (and currently only) billing settings object from the state.
// This may get more nuance in the future (eg a saleyard with mulitple billing settings/entities)
export const getDefaultBillingSettings = (
  state: State,
): BillingSettings | null =>
  Object.values(
    getBillingSettings(state) as Record<string, BillingSettings>,
  )?.[0] || null;

export const [
  selectBillingSettingsByBillingRunIdLookup,
  getBillingSettingsByBillingRunId,
] = createLookupSelectors(
  [selectBillingSettingsIdByBillingRunIdLookup, getBillingSettings],
  createLookupCombiner(
    (
      billingSettingsId: string,
      billingSettingsByIdLookup: Record<string, BillingSettings>,
    ): BillingSettings | null =>
      billingSettingsByIdLookup[billingSettingsId] || null,
  ),
);
